import { z } from "zod";

export const tdaSchema = z.object({
  idNumber: z
    .string()
    .trim()
    .min(1, "MYKAD/Passport is required")
    .refine(
      (value) => {
        if (/^\d/.test(value)) {
          return /^\d{6}-\d{2}-\d{4}$/.test(value);
        }

        return /^[A-Z0-9]{6,15}$/.test(value);
      },
      {
        message: "Please enter a valid MYKAD or Passport number",
      },
    ),
});

export type TdaValues = z.infer<typeof tdaSchema>;